import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HeartSquare = function HeartSquare(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9966 9.068c-.9997-1.1688-2.6667-1.4832-3.9193-.413s-1.4288 2.8595-.4452 4.1252c.63.8107 2.2435 2.314 3.3221 3.2902.3585.3243.5377.4865.7524.5516a1.024 1.024 0 0 0 .58 0c.2146-.0651.3939-.2273.7523-.5516 1.0787-.9762 2.6921-2.4795 3.3222-3.2902.9836-1.2657.8288-3.0663-.4453-4.1252s-2.9195-.7558-3.9192.413",
      clipRule: "evenodd"
    })]
  }));
};
export default HeartSquare;